<mat-tab-group
  #tabGroup
  class="tab-group"
  [mat-stretch-tabs]="true"
  color="warn"
>
  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.CustomerBasedataConfigFormComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.user"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <app-customer-base-data-config-form/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.BookingOptionsConfigFormComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.money"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <app-booking-options-config-form/>
      <app-sepa-config-form/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.OpenItemImportConfigFormComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.document"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <app-open-item-import-config-form/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.EpostConfigWrapperComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.email"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <app-epost-config-wrapper/>
      <lib-smtp></lib-smtp>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.MailTemplateComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.mail"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <lib-mail-template/>
    </ng-template>
  </mat-tab>

  <mat-tab *authorizeVisibility="AUTHORIZATION_CONFIG.VerificationRulesConfigFormComponent">
    <ng-template mat-tab-label>
          <span>
            <mat-icon [svgIcon]="EsvgFiles.settings"/>
          </span>
    </ng-template>

    <ng-template matTabContent>
      <app-verification-rules-config-form/>
    </ng-template>
  </mat-tab>
</mat-tab-group>
